<div class="modal-content m-0">
  <div class="modal-header">
    <p class="mb-0">{{ 'followUps.modal.detailsTitle' | translate }}</p>
    <i
      class="fa-light fa-xmark ms-auto cursor-pointer"
      data-cy="close-icon"
      (click)="close()"
    ></i>
  </div>
  <div class="modal-body">
    @if (followUp()) {
      <div>
        <div class="row mb-2">
          <div class="col-12 row align-items-center" data-cy="id-row">
            <label class="label col-2 mb-0 text-end">{{
              'followUps.modal.details.id' | translate
            }}</label>
            <div class="col-10">{{ followUp().id }}</div>
          </div>
        </div>
        <div class="row mb-2">
          <div
            class="col-12 row align-items-center"
            data-cy="reference-key-row"
          >
            <label class="label col-2 mb-0 text-end">{{
              'followUps.modal.details.referenceKey' | translate
            }}</label>
            <div class="col-10">{{ followUp().referenceKey }}</div>
          </div>
        </div>
        <div class="row mb-2">
          <div class="col-12 row align-items-center" data-cy="last-status-row">
            <label class="label col-2 mb-0 text-end">{{
              'followUps.modal.details.lastStatus' | translate
            }}</label>
            <div class="col-10">
              {{ 'followUps.list.status.' + followUp().lastStatus | translate }}
              -
              {{ followUp().lastStatusChanged | date }}
            </div>
          </div>
        </div>
        <div class="row mb-2">
          <div class="col-12 row align-items-center" data-cy="type-row">
            <label class="label col-2 mb-0 text-end">{{
              'followUps.modal.details.type' | translate
            }}</label>
            <div class="col-10">
              {{ 'followUps.types.' + followUp().type | translate }}
            </div>
          </div>
        </div>
        <div class="row mb-2">
          <div class="col-12 row align-items-center" data-cy="reason-row">
            <label class="label col-2 mb-0 text-end">{{
              'followUps.modal.details.reason' | translate
            }}</label>
            <div class="col-10">
              {{ 'followUps.reasons.' + followUp().reason | translate }}
            </div>
          </div>
        </div>
        <div class="row mb-2">
          <div class="col-12 row align-items-center" data-cy="reporter-row">
            <label class="label col-2 mb-0 text-end">{{
              'followUps.modal.details.reporter' | translate
            }}</label>
            <div class="col-10">
              {{ followUp().generatedBy | displayName: users }}
            </div>
          </div>
        </div>
        <div class="row mb-2">
          <div class="col-12 row align-items-center" data-cy="opened-row">
            <label class="label col-2 mb-0 text-end">{{
              'followUps.modal.details.opened' | translate
            }}</label>
            <div class="col-10">{{ followUp().generated | date }}</div>
          </div>
        </div>
        @if (followUp().inProgress) {
          <div class="row mb-2">
            <div class="col-12 row align-items-center" data-cy="assignee-row">
              <label class="label col-2 mb-0 text-end">{{
                'followUps.modal.details.assignee' | translate
              }}</label>
              <div class="col-10">
                {{ followUp().assignee | displayName: users }}
              </div>
            </div>
          </div>
          <div class="row mb-2">
            <div
              class="col-12 row align-items-center"
              data-cy="in-progress-row"
            >
              <label class="label col-2 mb-0 text-end">{{
                'followUps.modal.details.inProgress' | translate
              }}</label>
              <div class="col-10">
                {{ followUp().inProgress | date }}
              </div>
            </div>
          </div>
        }
        @if (followUp().resolved) {
          <div class="row mb-2">
            <div class="col-12 row align-items-center" data-cy="resolved-row">
              <label class="label col-2 mb-0 text-end">{{
                'followUps.modal.details.resolved' | translate
              }}</label>
              <div class="col-10">{{ followUp().resolved | date }}</div>
            </div>
          </div>
        }
        @if (followUp().archived) {
          <div class="row mb-2">
            <div class="col-12 row align-items-center" data-cy="archived-row">
              <label class="label col-2 mb-0 text-end">{{
                'followUps.modal.details.archived' | translate
              }}</label>
              <div class="col-10">{{ followUp().archived | date }}</div>
            </div>
          </div>
        }
        @if (followUp().notes) {
          <div class="row mb-2">
            <div class="col-12 row align-items-center" data-cy="notes-row">
              <label class="label col-2 mb-0 text-end">{{
                'followUps.modal.details.notes' | translate
              }}</label>
              <div class="col-10">{{ followUp().notes }}</div>
            </div>
          </div>
        }
      </div>
      <hr />
      <app-follow-up-timeline [followUp]="followUp()"></app-follow-up-timeline>
    } @else {
      <span
        class="spinner-border spinner-border-sm"
        role="status"
        aria-hidden="true"
      ></span>
    }
  </div>
  <div class="modal-footer">
    <button
      type="button"
      class="btn btn-clear"
      data-cy="close-btn"
      (click)="close()"
    >
      {{ 'common.buttons.btnClose' | translate }}
    </button>
  </div>
</div>
